module.exports = __webpack_public_path__ + "img/arrow-up-s-fill.b15210a7.svg";